module.exports = __webpack_public_path__ + "media/images/icons/country_flags/arab-1b9aa1f0e728775aec22a8dcdf017571.svg";